import { TYPES } from "./default_hacker.type";

const initState = {
  defaultHackerAll: null,
};

const defaultHackerReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_HACKER_ALL:
      return {
        ...state,
        defaultHackerAll: payload,
      };

    default:
      return state;
  }
};

export default defaultHackerReducer;
